export default __webpack_public_path__ + "static/media/chat_bg.bded4f44.png";